import { useConfigContext } from "shared/hooks";

import ButtonResetChatIframe from "./ButtonResetChatIframe";
import ButtonResetChatNonIframe from "./ButtonResetChatNonIframe";
import { Props } from "./types";

function ButtonResetChat(props: Props) {
  const { isIframe } = useConfigContext();

  if (isIframe) {
    return <ButtonResetChatIframe {...props} />;
  }
  return <ButtonResetChatNonIframe {...props} />;
}

export default ButtonResetChat;
